// src/components/ResourcesSidebar.js
import React from 'react';
import { NavLink } from 'react-router-dom';

function ResourcesSidebar() {
  return (
    <aside className="resources-sidebar" aria-label="Resources Sidebar">
      <div className="resources-tab">
        <span>Resources</span>
      </div>
      <div className="resources-content">
        <h5>Learning Resources</h5>
        <ul className="list-unstyled">
          <li>
            <a href="https://developer.mozilla.org" target="_blank" rel="noopener noreferrer" className="resource-link">
              MDN Web Docs
            </a>
          </li>
          <li>
            <a href="https://www.w3schools.com" target="_blank" rel="noopener noreferrer" className="resource-link">
              W3Schools
            </a>
          </li>
          <li>
            <a href="https://getbootstrap.com/docs/5.3/getting-started/introduction/" target="_blank" rel="noopener noreferrer" className="resource-link">
              Bootstrap Docs
            </a>
          </li>
          <li>
            <a href="https://react.dev" target="_blank" rel="noopener noreferrer" className="resource-link">
              React Docs
            </a>
          </li>
          <li>
            <a href="https://code.visualstudio.com/docs" target="_blank" rel="noopener noreferrer" className="resource-link">
              VS Code Docs
            </a>
          </li>
          <hr></hr>
          <h5>Animation Resources</h5>
          <li>
            <a href="https://lottiefiles.com" target="_blank" rel="noopener noreferrer" className="resource-link">
              LottieFiles
            </a>
          </li>

          <hr></hr>

          <h5>Javascript Frameworks</h5>
          <li>
            <a href="https://react.dev" target="_blank" rel="noopener noreferrer" className="resource-link">
              React.js
            </a>
          </li>
          <li>
            <a href="https://angular.dev" target="_blank" rel="noopener noreferrer" className="resource-link">
              Angular.js
            </a>
          </li>
          <li>
            <a href="https://vuejs.org" target="_blank" rel="noopener noreferrer" className="resource-link">
              Vue.js
            </a>
          </li>
          <li>
            <a href="https://svelte.dev" target="_blank" rel="noopener noreferrer" className="resource-link">
              Svelte.js
            </a>
          </li>
          <li>
            <a href="https://emberjs.com" target="_blank" rel="noopener noreferrer" className="resource-link">
              Ember.js
            </a>
          </li>

          <hr></hr>

          <h5>CSS Resources</h5>
          <li>
            <a href="https://tailwindcss.com/" target="_blank" rel="noopener noreferrer" className="resource-link">
              Tailwind
            </a>
          </li>
          <li>
            <a href="https://getbootstrap.com" target="_blank" rel="noopener noreferrer" className="resource-link">
              Bootstrap
            </a>
          </li>
          <li>
            <a href="https://get.foundation" target="_blank" rel="noopener noreferrer" className="resource-link">
              Foundation
            </a>
          </li>
          <li>
            <a href="https://bulma.io" target="_blank" rel="noopener noreferrer" className="resource-link">
              Bulma
            </a>
          </li>
          <li>
            <a href="https://semantic-ui.com" target="_blank" rel="noopener noreferrer" className="resource-link">
              Semantic UI
            </a>
          </li>
        </ul>
      </div>
    </aside>
  );
}

export default ResourcesSidebar;